interface IntegrationVideoProps {
  src: string;
  label: string;
  'data-testid'?: string;
}

export const IntegrationVideo = ({ src, label, ...props }: IntegrationVideoProps) => (
  <div className="space-y-2">
    <p className="text-sm font-medium text-foreground">{label}</p>
    <iframe
      src={src}
      title={label}
      className="aspect-video w-full rounded-lg border border-border"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      data-testid={props['data-testid']}
    />
  </div>
);
